import script from "./appHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./appHeader.vue?vue&type=script&setup=true&lang=js"

import "./appHeader.vue?vue&type=style&index=0&id=6579c193&lang=css"

const __exports__ = script;

export default __exports__